import { mapGetters } from 'vuex';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';

export default {
    name: 'homehotlead',
    components: {
        mvtHotleadForm,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
    },
    data() {
        return {
            hotleadOpt: {
                title: '',
                hotleadType: 'ExpertConsultConsumerGlobalHomePageBottom',
                buttonText: this.molang('home.submit'),
                hideProfile: true,
                showZipcode: true,
                placeholder: {
                    name: 'First name Last name',
                    email: 'name@email.com',
                    phone: '(123) 456-789',
                },
            },
        };
    },
};
